<template>
    <v-row class="white-card with-border no-shadow px-3">
        <v-col cols="12">
            <v-row align="center">
                <v-col cols="6">
                    <v-img :src="require('@/assets/logos/logo_name.png')" eager width="150" contain/>
                </v-col>
                <v-col cols="6" class="caption-light grey-color text-end" align="right">
                    <div>
                        Orden n° {{ orderNumber }}
                    </div>
                    <div class="mt-1">
                        Fecha de emisión {{ emitDate }}
                    </div>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" class="center headline-heavy primary-color">
            Solicitud de exámenes
        </v-col>
        <v-col cols="12">
            <label-input label="Paciente" :value="nameUser"/>
        </v-col>
        <v-col cols="6" class="pt-0">
            <label-input label="Edad" :value="birthDateUser"/>
        </v-col>
        <v-col cols="6" class="pt-0">
            <label-input label="Rut" :value="rutUser"/>
        </v-col>
        <v-col cols="12">
            <v-divider/>
        </v-col>
        <v-col cols="12" v-if="title" class="primary-color subheader-heavy">
            {{ title }}
        </v-col>
        <v-col cols="12" md="4" v-for="(exam,i) in exams" :key="i">
            <v-row class="px-3">
                <v-col cols="12" class="pl-0">
                    <div class="body-heavy primary-color text-truncate">
                        {{ exam.name }}
                    </div>
                    <div class="mt-1 caption-light grey-color text-truncate">
                        {{ exam.preparation.name }}
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import LabelInput from "@/components/common/LabelInput";

export default {
    name: "OrderPreview",
    components: {LabelInput},
    props: {
        user: {
            type: Object,
            default: null,
        },
        exams: {
            type: Array,
            default: () => [],
        },
        order: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        downloadMode: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        orderNumber(vm = this) {
            return vm.order?.id || 'XXXXXX'
        },
        emitDate(vm = this) {
            if (vm.order) return vm.$moment(vm.order.created_at).format('DD/MM/YY')
            return vm.$moment().format('DD/MM/YY')
        },
        nameUser(vm = this) {
            if (vm.user) return `${vm.user.name} ${vm.user.last_name}`
            return `${vm.currentUser.name} ${vm.currentUser.last_name}`
        },
        birthDateUser(vm = this) {
            if (vm.user && vm.user.birth_date) return vm.$moment().diff(vm.$moment(vm.user.birth_date), 'years') + ' años'
            if (vm.currentUser.birth_date) return vm.$moment().diff(vm.$moment(vm.currentUser.birth_date), 'years') + ' años'
            return 'n/d'
        },
        rutUser(vm = this) {
            let rut = vm.user?.rut || vm.currentUser?.rut || null
            return rut && vm.$options.filters.rutificador(rut) || 'n/d'
        },
    }
}
</script>

<style scoped>

.center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

</style>